export const BLOCK_HORIZONTAL_PADDING = 16;
export const BLOCK_VERTICAL_PADDING = 12;
export const BLOCK_HEIGHT = 64;
export const BLOCK_BORDER_RADIUS = 12;
export const SMALL_FONT_SIZE = 12;
export const BASE_FONT_SIZE = 14;
export const LARGE_FONT_SIZE = 16;
